import React, { Component } from "react";
import validator from "validator";
import Autocomplete from "react-autocomplete";
import { connect } from "react-redux";
import { I18n, Translate } from "react-redux-i18n";

import {
  createBranchManager,
  updateBranchManager,
} from "../../app/store/actions/branch_manager";
import FIELDS from "../../data/fields";

class BranchManagerFormComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      storeBranchCode: "",
      branchName: "",
      emailManager: "",
      message: "",
      success: "",
      value: "",
      status: "",
    };
  }

  componentDidMount() {
    const { branchManagerComming, settings } = this.props;

    if (
      !settings ||
      !settings.locations ||
      !settings.locations.rows ||
      settings.locations.rows.length === 0
    ) {
      this.props.getBranches();
    }

    if (branchManagerComming) {
      this.setState({
        id: branchManagerComming.id,
        storeBranchCode: branchManagerComming.storeBranchCode,
        branchName: branchManagerComming.branchName,
        emailManager: branchManagerComming.emailManager,
        status: branchManagerComming.status,
      });
    }
  }

  goBack = () => {
    this.props.back.goBack();
  };

  setOnChange = (value) => {
    this.setState({ value, message: "", success: "" });
  };

  toggleStatus = () => {
    const { status } = this.state;
    this.setState({
      status: status === "active" ? "inactive" : "active",
      message: "",
      success: "",
    });
  };

  setSelectedLocation = (item) => {
    return `${item.location.crmTag} - ${item.location.name}`;
  };

  setSelectedLocationId = (locationValue) => {
    const { branches } = this.props;
    const selectedBranch = branches.find(
      (b) => `${b.location.crmTag} - ${b.location.name}` === locationValue
    );

    if (selectedBranch) {
      this.setState({
        value: locationValue,
        storeBranchCode: selectedBranch.location.id,
        branchName: selectedBranch.location.name,
      });
    }
  };

  validations = () => {
    const { storeBranchCode, branchName, emailManager } = this.state;
    const errors = {};

    if (!storeBranchCode) {
      errors.storeBranchCode = I18n.t("selectStoreBranch");
    }
    if (!branchName) {
      errors.branchName = I18n.t("selectBranchName");
    }
    if (!emailManager) {
      errors.emailManager = I18n.t("selectEmailManager");
    } else if (emailManager.length > 254) {
      errors.emailManager = I18n.t("emailTooLong");
    } else if (
      emailManager.includes(",") ||
      emailManager.includes(";") ||
      emailManager.includes(" ")
    ) {
      errors.emailManager = I18n.t("onlyOneEmailAllowed");
    } else if (!validator.isEmail(emailManager)) {
      errors.emailManager = I18n.t("invalidEmail");
    }

    return errors;
  };

  backendErrors = (error) => {
    if (error.response && error.response.data && error.response.data.error) {
      const errorCode = error.response.data.error.code;
      if (errorCode === 1624) {
        this.setState({
          success: "",
          message: I18n.t("branchManagerAlreadyExists"),
        });
      } else if (errorCode === 1625) {
        this.setState({
          success: "",
          message: I18n.t("onlyOneEmailAllowed"),
        });
      } else if (errorCode === 1626) {
        this.setState({
          success: "",
          message: I18n.t("invalidEmail"),
        });
      } else {
        this.setState({ success: "", message: I18n.t("errorOcurred") });
      }
    } else {
      this.setState({ success: "", message: I18n.t("errorOcurred") });
    }
  };

  saveBranchManager = async () => {
    const { storeBranchCode, branchName, emailManager } = this.state;
    const errors = this.validations();

    if (errors.storeBranchCode) {
      this.setState({ success: "", message: errors.storeBranchCode });
      return;
    }
    if (errors.branchName) {
      this.setState({ success: "", message: errors.branchName });
      return;
    }
    if (errors.emailManager) {
      this.setState({ success: "", message: errors.emailManager });
      return;
    }

    try {
      await this.props.createBranchManager({
        storeBranchCode,
        branchName,
        emailManager,
        status: "active",
      });
      this.setState({
        id: null,
        storeBranchCode: "",
        branchName: "",
        emailManager: "",
        value: "",
        success: I18n.t("branchManagerCreated"),
        message: "",
      });
    } catch (err) {
      this.backendErrors(err);
    }
  };

  updateBranchManager = async () => {
    const { id, storeBranchCode, branchName, emailManager, status } =
      this.state;

    const errors = this.validations();

    if (errors.emailManager) {
      this.setState({ success: "", message: errors.emailManager });
      return;
    }

    try {
      await this.props.updateBranchManager({
        id,
        storeBranchCode,
        branchName,
        emailManager,
        status,
      });
      this.setState({
        success: I18n.t("branchManagerUpdated"),
        message: "",
      });
    } catch (err) {
      this.backendErrors(err);
    }
  };

  render() {
    const {
      storeBranchCode,
      branchName,
      emailManager,
      message,
      success,
      value,
      status,
    } = this.state;
    const { branchManagerComming, branches = [] } = this.props;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          <Translate value="branchManager" />
        </h2>
        <form>
          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              <Translate value="place" />
            </p>
            {branchManagerComming ? (
              <input
                type="text"
                value={branchName}
                className="form-control"
                disabled
              />
            ) : (
              <Autocomplete
                getItemValue={(item) => this.setSelectedLocation(item)}
                items={branches}
                className="custom-select"
                maxLength={FIELDS.max}
                renderItem={(item, isHighlighted) => (
                  <div
                    style={{
                      background: isHighlighted ? "lightgray" : "white",
                    }}
                  >
                    {item.codePlace}
                    {" - "}
                    {item.location.crmTag}
                    {" - "}
                    {item.location.name}
                  </div>
                )}
                value={value}
                onChange={(e) => this.setOnChange(e.target.value)}
                onSelect={(e) => this.setSelectedLocationId(e)}
              />
            )}
          </div>

          {storeBranchCode && (
            <div className="form-group">
              <p className="margin-bottom-2">
                <Translate value="storeBranchCode" />
              </p>
              <input
                type="text"
                value={storeBranchCode}
                className="form-control"
                disabled
              />
            </div>
          )}

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="emailManager" /> Comercial
            </p>
            <input
              type="email"
              value={emailManager}
              className="form-control"
              placeholder=""
              onChange={(e) =>
                this.setState({
                  emailManager: e.target.value,
                  message: "",
                  success: "",
                })
              }
              maxLength={FIELDS.max}
            />
          </div>

          {branchManagerComming && (
            <div className="form-check">
              <input
                onClick={this.toggleStatus}
                type="checkbox"
                className="form-check-input"
                checked={status === "active" ? true : false}
                id="isDisableCheck"
              />
              <span>
                <Translate value="active2" />
              </span>
            </div>
          )}

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>
            {branchManagerComming ? (
              <button
                type="button"
                onClick={() => this.updateBranchManager()}
                className="btn btn-dark"
              >
                <Translate value="update" />
              </button>
            ) : (
              <button
                type="button"
                onClick={() => this.saveBranchManager()}
                className="btn btn-dark"
              >
                <Translate value="save" />
              </button>
            )}
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  createBranchManager: (data) => dispatch(createBranchManager(data)),
  updateBranchManager: (data) => dispatch(updateBranchManager(data)),
});

const mapStateToProps = (state) => {
  const settingsLocations =
    state.settings && state.settings.locations && state.settings.locations.rows;

  return {
    branches: settingsLocations || [],
    settings: state.settings,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchManagerFormComponent);
